import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";
// Constants
import { TITLE, SUB_TITLE, TITLE_2_CARDS, SUB_TITLE_2_CARDS, ALL_CARD_ROWS_2, ALL_CARD_ROWS, TITLE_3_CARDS, SUB_TITLE_3_CARDS, BUTTON_ONE_NAME, BUTTON_ONE_LINK, BUTTON_SECOND_NAME, BUTTON_SECOND_LINK} from "./VippPageConstants";
import { TITLE_NOTES, BODY_NOTES } from "./VippPageConstants";
import { SIGN_UP_TITLE, SIGN_UP_SUB_TITLE, BANNER_LINK, BUTTON_NAME_SIGN_UP } from "./VippPageConstants";
// Images
import partnerProgramLogo from '../../../assets/img/partnerProgram/banner.png';

// Scss
import '../../../assets/css/partnerProgram.scss';
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/salesEnablement.scss';
import CardsFormatThree from "../../../components/CardsFormatThree";
import Notes from "../../../components/Notes";
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";
import SignUpBlock from "../../../components/SignUpBlock";

function VippPage() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <BannerOne mainClass="margin96Botton" bannerImage={partnerProgramLogo} title={TITLE} subTitle={SUB_TITLE} hasNoButton={true} />

        <div className="margin96Botton width64 ml-auto mr-auto">
            <TitleSubTitleCenter addClass={"ml-auto mr-auto"} title={"How does the program work?"} subTitle={"Our new program is a continuation of the overall Dynatrace partner ecosystem mission, built to help you — our partners — increase your business profitability, reward you for achieving new business growth targets, and help accelerate your business success in the Dynatrace observability market."} />
            <CardsFormatThree addClass="p-0" cards={ALL_CARD_ROWS} />
        </div>

        <div className="margin96Botton width64 ml-auto mr-auto">
            <TitleSubTitleCenter addClass={"ml-auto mr-auto"} title={TITLE_2_CARDS} subTitle={SUB_TITLE_2_CARDS} />
            <CardsFormatThree addClass="p-0" cards={ALL_CARD_ROWS_2} />
        </div>

        <div className="margin96Botton width64 ml-auto mr-auto">
            <TitleSubTitleCenter addClass={"ml-auto mr-auto"} title={TITLE_3_CARDS} subTitle={SUB_TITLE_3_CARDS} hasButtons={true} buttonOneName={BUTTON_ONE_NAME} buttonOneLink={BUTTON_ONE_LINK} buttonOneWidth={"width24_31"} buttonOnepadding={"pb-4 pt-4"} buttonSecondName={BUTTON_SECOND_NAME} buttonSecondLink={BUTTON_SECOND_LINK} buttonSecondWidth={"width19"} />
        </div>
        

        <SignUpBlock title={SIGN_UP_TITLE} subTitle={SIGN_UP_SUB_TITLE} bannerLink={BANNER_LINK} buttonName={BUTTON_NAME_SIGN_UP} target={"_parent"}  />

        
        <div className="d-flex flex-column align-items-start width53 margin96Top ml-auto mr-auto changeWidth">
            <Notes title={TITLE_NOTES} body={BODY_NOTES}/>
        </div>
        
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default VippPage;

